import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateStatusPayload, MigrateStatusPayload, PermitStatus, StatusEdition, StatusMigrationResult, UpdateStatusConfigPayload } from '../models/permit-status.model';

@Injectable()
export class PermitStatusService {
    private readonly baseUrl = `${environment.API_GATEWAY_URL}/permit/admin/permit-status`;

    constructor(private http: HttpClient) {}

    getDefaultStatuses(): Observable<PermitStatus[]> {
        return this.http.get<PermitStatus[]>(`${this.baseUrl}/default-status`);
    }

    getAllStatuses(raw = false): Observable<PermitStatus[]> {
        const params = raw ? new HttpParams().set('raw', 'true') : undefined;
        return this.http.get<PermitStatus[]>(this.baseUrl, { params });
    }

    getCreatedStatuses(): Observable<PermitStatus[]> {
        return this.http.get<PermitStatus[]>(`${this.baseUrl}/created`);
    }

    getStatusById(id: string): Observable<PermitStatus> {
        return this.http.get<PermitStatus>(`${this.baseUrl}/${id}`);
    }

    getStatusEdition(id: string): Observable<StatusEdition> {
        return this.http.get<StatusEdition>(`${this.baseUrl}/${id}/edition`);
    }

    createStatus(payload: CreateStatusPayload): Observable<PermitStatus> {
        return this.http.post<PermitStatus>(this.baseUrl, payload);
    }

    updateStatus(id: string, payload: UpdateStatusConfigPayload): Observable<PermitStatus> {
        return this.http.patch<PermitStatus>(`${this.baseUrl}/${id}`, payload);
    }

    deleteStatus(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    migrateStatus(sourceId: string, payload: MigrateStatusPayload): Observable<StatusMigrationResult> {
        return this.http.post<StatusMigrationResult>(`${this.baseUrl}/${sourceId}/migration`, payload);
    }
}
